import React from "react";

const HalfSemiChart = ({ color, fill }) => {
	return (
		<div
			className="semi-donut"
			style={{
				"--percentage": fill,
				"--fill": color,
				"--pie-width": "5px",
				width: "50px",
			}}
		>
			<small className="semi-txt">{fill}%</small>
		</div>
	);
};

export default HalfSemiChart;
